// WIP
import React, { useEffect, useState } from 'react';

import { Box, useTheme } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { useQueryClient } from '@tanstack/react-query';
import SectionLoadingView from 'components/MeshList/SectionLoadingView';
import CreateGoalPanel from 'components/MeshList/goals/CreateGoalPanel';
// import useForceUpdate from 'components/hooks/useForceUpdate';
import { useInView } from 'react-intersection-observer';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { openCreateOKRPanel } from 'reducers/createObjectivePanelSlice';
import { useOKROwnership } from 'reducers/okrsPageSlice';
import { GoalsMySummaryAgGrid } from 'screens/home/summary/components/Cards/Goals/components/GoalsMySummaryAgGrid';

import NoDataImg from 'assets/assetsV1/illustrations/noGoals.svg';

import { OKR_TYPES } from 'constants/ProjectConstants';
import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { EmptyScreen } from 'uiToolkitV1/EmptyScreen';

import { useGoalsCascadedViewData } from '../AgGridTreeView/hooks/dataHooks';
import CardHeader from './CardHeader';

const CardContainer = styled(Box)`
  height: 100%;
  border-radius: 4px;
  padding: 16px;
  background: ${(props) => props.theme.colors.common.white};
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

const CardBodyContainer = styled(Box)`
  flex: 1;
  overflow-y: auto;
`;

const CardBody = styled(Box)`
  margin: 0;
`;

const StyledImage = styled.img`
  max-width: 70%;
`;

const GROUP_BY = {
  uuid: null,
  keyName: 'objective',
  displayName: 'Objective',
  enabled: true,
};

const SPLIT_BY = {
  uuid: null,
  keyName: 'none',
  displayName: 'None',
  enabled: true,
};

// TODO: There will be meshlist home page and meshlist team view, two separate views
// and this one will be modular
const RabbitListContainerAgGrid = ({ employee, stats, timeBoundPeriod, selectedCohort = null }) => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const theme = useTheme();

  const { ref, inView } = useInView({
    triggerOnce: true,
  });

  const queryClient = useQueryClient();

  const refetchCascadedViewData = () => {
    queryClient.invalidateQueries([
      REACT_QUERY_KEYS.GoalsCascadedData,
      selectedCohort?.id,
      GROUP_BY,
      SPLIT_BY,
      null,
      [timeBoundPeriod],
      {
        filterConditions: [
          {
            type: 'NAME',
            operatorType: 'IN',
            data: [employee?.id],
          },
          {
            type: 'TYPE',
            operatorType: 'IN',
            data: ['GOAL'],
          },
        ],
      },
      false,
    ]);
  };

  // const [forceUpdateValue, forceUpdate] = useForceUpdate();
  const [isOpenCreateGoalPanel, setIsOpenCreateGoalPanel] = useState(false);
  const [createNewInProgress, setCreateNewInProgress] = useState(false);

  const [isEnabled, setIsEnabled] = useState(false);
  const ownership = useOKROwnership();

  const { data, isLoading } = useGoalsCascadedViewData({
    attributeFilter: {
      filterConditions: [
        {
          type: 'NAME',
          operatorType: 'IN',
          data: [employee?.id],
        },
        {
          type: 'TYPE',
          operatorType: 'IN',
          data: ['GOAL'],
        },
      ],
    },
    cohort: selectedCohort,
    groupByKeys: GROUP_BY,
    splitByKeys: SPLIT_BY,
    orderBy: null,
    timeBounds: [timeBoundPeriod],
    isHierarchyView: false,
    pageType: 'PROFILE_PAGE',
    enabled: isEnabled,
    ownership,
  });

  const createNewHandler = () => {
    dispatch(
      openCreateOKRPanel({
        selectedObjective: null,
        selectedTimeBoundPeriod: timeBoundPeriod,
        okrPanelType: OKR_TYPES.KEY_RESULT,
        ownerEmployee: employee,
        onKeyResultCreation: refetchCascadedViewData,
        onObjectiveCreation: refetchCascadedViewData,
        history,
        location,
      })
    );
  };

  useEffect(() => {
    if (!inView) return;

    setIsEnabled(true);
  }, [inView]);
  return (
    <CardContainer>
      <Box ref={ref} borderBottom={`1px solid ${theme.colors.border.CFD7DF}`}>
        <CardHeader
          employee={employee}
          stats={stats}
          createNewHandler={createNewHandler}
          createNewInProgress={createNewInProgress}
        />
      </Box>

      <CardBodyContainer>
        <CardBody>
          {isLoading ? (
            <SectionLoadingView />
          ) : (
            <>
              {data?.length === 0 ? (
                <EmptyScreen
                  heading="This list is empty"
                  description="In the beginners mind, there are only possibilities. Create a goal, make possibilities real."
                  illustrationSrc={NoDataImg}
                />
              ) : (
                <GoalsMySummaryAgGrid
                  refetchCascadedViewData={refetchCascadedViewData}
                  data={data}
                  selectedTimeline={timeBoundPeriod}
                  isProfilePage
                />
              )}
            </>
          )}
        </CardBody>
      </CardBodyContainer>
      <CreateGoalPanel
        open={isOpenCreateGoalPanel}
        onCancel={() => {
          setIsOpenCreateGoalPanel();
          setCreateNewInProgress(false);
        }}
        afterGoalCreation={refetchCascadedViewData}
        employee={employee}
        eventSource="Team Page"
      />
    </CardContainer>
  );
};

export { RabbitListContainerAgGrid };
